
export default function reset_password( state = { 'OUTPUT' : { 'DATA' : [1] } }, action = {} ){

    switch( action.type ){
        case 'RESET_PASSWORD':
            return action.reset_password
        case 'SEND_VERIFICATION':
            return action.reset_password
        default: return state;
    }

}



// WEBPACK FOOTER //
// ./src/store/reducers/reset/reset.reducer.js